module.exports = __webpack_public_path__ + "img/headphones.14a6082f.svg";